var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCloseThin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 11.71 11.71",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.93,11.71a.7.7,0,0,1-.5-.21L5.85,6.85,1.19,11.43a.71.71,0,0,1-1,0,.7.7,0,0,1,0-1L4.87,5.85.28,1.19a.71.71,0,0,1,0-1,.71.71,0,0,1,1,0L5.86,4.87,10.52.29a.71.71,0,0,1,1,0,.7.7,0,0,1,0,1L6.85,5.86l4.58,4.66a.71.71,0,0,1,0,1A.69.69,0,0,1,10.93,11.71Z",
    fill: "#456d86"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseThin);
export default __webpack_public_path__ + "static/media/close_thin.21ad1065c6360644c5c2b3bf19ee6372.svg";
export { ForwardRef as ReactComponent };